module.exports = __webpack_public_path__ + "img/user_4.6f19ef2c.png";